import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import Loader from '../../components/Loader';
import MarketCard from '../../components/MarketCard';
import useGetData from '../../hooks/marketplace/useGetData';

const Campaigns = () => {
  const { company } = useParams();
  const [page, setPage] = useState(0);
  const [filters, setFilters] = useState({ stage: [1] });

  const { data, loading, error } = useGetData('campaigns', {
    body: { company, filters },
  });
  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
  };
  if (loading) return <Loader />;
  if (error) return <h1>Error al cargar las campañas.</h1>;
  const campaigns = data ? data.campaigns : [];

  return (
    <>
      <div className='button-bar'>
        <button
          className={page === 0 ? 'active' : ''}
          onClick={() => {
            setPage(0);
            handleFilterChange({ active: true, stage: [1] });
          }}>
          Activas
        </button>
        <button
          className={page === 1 ? 'active' : ''}
          onClick={() => {
            setPage(1);
            handleFilterChange({ active: true, stage: [2] });
          }}>
          En ejecución
        </button>
        <button
          className={page === 2 ? 'active' : ''}
          onClick={() => {
            setPage(2);
            handleFilterChange({ active: true, stage: [4] });
          }}>
          Completadas
        </button>
      </div>
      {campaigns.length === 0 ? (
        <h1>No hay nada que ver acá....aún</h1>
      ) : (
        campaigns.map((campaign, index) => (
          <MarketCard
            key={index}
            data={{
              ...campaign,
              type: 'campaign',
            }}
          />
        ))
      )}
    </>
  );
};

export default Campaigns;
